import { render, staticRenderFns } from "./AggiungiMisurazione.vue?vue&type=template&id=4c526210"
import script from "./AggiungiMisurazione.vue?vue&type=script&lang=js"
export * from "./AggiungiMisurazione.vue?vue&type=script&lang=js"
import style0 from "./AggiungiMisurazione.vue?vue&type=style&index=0&id=4c526210&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports